import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_OFFERCLICK = 'ddc.link.offerClick';

function incentive(
	{
		DDC: {
			modules: { dialog }
		}
	},
	doc,
	{ currentTarget: element, timeStamp }
) {
	let eventObject;
	const $element = $(element);

	if (
		!eventHasRun(DDC_LINK_OFFERCLICK, {
			timeStamp
		})
	) {
		// Set up the dialog link clicks
		if ($element.hasClass('dialog')) {
			$(doc).trigger('modulesRefresh', {
				modules: {
					dialog
				}
			});
		}

		const offerId = $element.data('incentive-id');
		const offerName = $element.data('incentive-name');

		eventObject = {
			eventType: DDC_LINK_OFFERCLICK,
			eventData: {
				offerId,
				offerName,
				element
			}
		};
	}

	return eventObject;
}

export default incentive;
